export default __webpack_public_path__ + "static/media/home_p.72df30a7.png";